import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  DELETE_ROLE_ACTION_TYPE,
  INSERT_UPDATE_ROLES_ACTION_TYPE,
  ROLES_LIST_ACTION_TYPE,
  ROLE_DETAILS_ACTION_TYPE,
  headers,
  insertUpdateRoleUrl,
  roleDeleteUrl,
  roleDetailUrl,
  roleListUrl,
} from "../../utils/constants";

export const role_list_action =
  (Name, is_active) => async (dispatch) => {
    try {
      const mapdata = {
        Name: Name != "" ? Name.toString().trim() : "",
        is_active: is_active
      };
      const params = {
        Name: mapdata.Name === "" ? null : mapdata.Name,
        is_active: mapdata.is_active === 0 ? 0 : 1
      };
      const res = await axiosGet(roleListUrl, params, headers);
      dispatch({
        type: ROLES_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const role_detail_action = (role_id) => async (dispatch) => {
  try {
    const params = {
      user_id: sessionStorage.getItem("user_id") != "" ? sessionStorage.getItem("user_id") : null,
      role_id: role_id != 0 ? role_id : 0,
    };
    const res = await axiosGet(roleDetailUrl, params, headers);
    dispatch({
      type: ROLE_DETAILS_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const role_insertUpdate_action =
  (role_id, Name, Description, moduleAccessList, reportAccessList) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          role_id: role_id ? role_id : null,
          Name: Name,
          Description: Description,
          moduleAccessList: moduleAccessList,
          reportAccessList: reportAccessList
        };
        const res = await axiosPost(insertUpdateRoleUrl, mapdata, headers);
        dispatch({
          type: INSERT_UPDATE_ROLES_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const role_delete_action = (role_id) => async (dispatch) => {
  try {
    const mapdata = {
      user_id:
        sessionStorage.getItem("user_id") != ""
          ? sessionStorage.getItem("user_id")
          : null,
      role_id: role_id ? role_id.toString().trim() : "",
    };

    const res = await axiosGet(roleDeleteUrl, mapdata, headers);
    dispatch({
      type: DELETE_ROLE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
